import Header from '../utill/Header';
import Footer from '../utill/Footer';
import Sidebar from '../utill/Sidebar';
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Button, Card, Form, Table} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"

interface ClientCustomerCode {
    customerCode: string;
    customerName: string;
    description: string;
    loginId: string;
    deleteYn: string;
    deleteDtm: string;
    registerUser: string;
    registerDtm: string;
    updateUser: string;
    updateDtm: string;
}

function ClientManagement() {
    const url = useContext(Url);
    const navigate = useNavigate();
    const [selected, setSelected] = useState("1");
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState<ClientCustomerCode[]>([]);
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 정보 관리'
        if (auth.MENUAUTH?.SET0200?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        setWriteAuthorityYn(auth.MENUAUTH?.SET0200?.writeAuthorityYn === "1");
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'customercode/findall ', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                })
        })
    }, []);

    const handleSubmit = async () => {
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'customercode/find', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                },
                params: {
                    data: searchText,
                    type: selected,
                }
            })
                .then((response) => {
                    setData(response.data.result.data)
                })
        })
    }

    const handleAddClick = () => {
        navigate('/ClientAdd')
    }

    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }

    let selectedValueTitle = "";
    let selectedValueContent = "";

    if (selected === "1") {
        selectedValueTitle = "고객사 코드로";
        selectedValueContent = "고객사 코드를";
    } else if (selected === "2") {
        selectedValueTitle = "고객사 명으로";
        selectedValueContent = "고객사 명을";
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
        }
    }

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0200"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='고객사 정보 관리'/>
                        <p className="header-message">고객사 정보를 관리합니다. 해당 고객사 코드, 고객사 명, 설명을 클릭하면 정보를 수정, 삭제 할 수 있습니다.</p>
                        <Card className="card shadow mb-4" style={{minHeight: "670px"}}>
                            <Card.Header className="py-3">
                                <div>
                                    <h6 className="m-0 font-weight-bold text-primary">{selectedValueTitle} 검색</h6>
                                    <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                </div>
                                <Form id="searchForm">
                                    <div className="form-group row">
                                        <Form.Select className="select_box" id='search_select' value={selected}
                                                     onChange={handleChangeSelect}>
                                            <option value="1">고객사 코드</option>
                                            <option value="2">고객사 명</option>
                                        </Form.Select>
                                        <Form.Control type="text" value={searchText}
                                                      onChange={(e) => setSearchText(e.target.value)}
                                                      onKeyDown={handleKeyDown}/>
                                        <div className="search_button_area">
                                            <Button variant="primary" className="search_button"
                                                    onClick={handleSubmit}>검색</Button>
                                            {writeAuthorityYn && <Button className="search_button" style={{marginLeft:'1rem'}} onClick={handleAddClick}>고객사 등록</Button>}
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">고객사 코드</StyledTableCell>
                                                <StyledTableCell align="center">고객사 명</StyledTableCell>
                                                <StyledTableCell align="center">설명</StyledTableCell>
                                                <StyledTableCell align="center">삭제 여부</StyledTableCell>
                                                <StyledTableCell align="center">삭제 일시</StyledTableCell>
                                                <StyledTableCell align="center">등록자</StyledTableCell>
                                                <StyledTableCell align="center">등록일시</StyledTableCell>
                                                <StyledTableCell align="center">수정자</StyledTableCell>
                                                <StyledTableCell align="center">수정일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map((data) => (
                                                <TableRow component={Link} to='/ClientModify' className="custom-link"
                                                          state={{
                                                              customerCode: data.customerCode,
                                                              customerName: data.customerName,
                                                              description: data.description,
                                                              loginId: data.loginId
                                                          }}
                                                          key={data.customerCode}
                                                          sx={{
                                                              '&:hover td': {
                                                                  backgroundColor: 'rgba(0,111,255,0.13)'
                                                              },
                                                              '&:active td': {
                                                                  backgroundColor: 'rgba(0,149,255,0.13)'
                                                              }
                                                          }}
                                                >
                                                    <StyledTableCell align="center">{data.customerCode || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.customerName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.description || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.deleteYn === "0" ? "사용중" : "삭제됨"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.deleteDtm ? data.deleteDtm.replace('T', ' ') : "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.registerUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.updateUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.updateDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>) : (<TableBody>
                                            {data.map((data) => (
                                                <TableRow
                                                    key={data.customerCode}
                                                    sx={{
                                                        '&:hover td': {
                                                            backgroundColor: 'rgba(0,111,255,0.13)'
                                                        },
                                                        '&:active td': {
                                                            backgroundColor: 'rgba(0,149,255,0.13)'
                                                        }
                                                }}
                                                >
                                                    <StyledTableCell align="center">{data.customerCode || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.customerName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.description || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.deleteYn === "0" ? "사용중" : "삭제됨"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.deleteDtm ? data.deleteDtm.replace('T', ' ') : "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.registerUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.updateUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{data.updateDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>)}
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                        <div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}



export default ClientManagement;